exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-ideas-report-about-js": () => import("./../../../src/pages/ideas-report/about.js" /* webpackChunkName: "component---src-pages-ideas-report-about-js" */),
  "component---src-pages-ideas-report-index-js": () => import("./../../../src/pages/ideas-report/index.js" /* webpackChunkName: "component---src-pages-ideas-report-index-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

